<template>
  <v-btn
    size="x-large"
    :color="buttonColor"
    :variant="buttonVariant"
    :disabled="disabled"
    block
    :style="{ fontSize: $vuetify.display.smAndDown ? '12px' : '' }"
    >{{ text }}</v-btn
  >
</template>
<script>
export default {
  name: "ThemedActionButton",
  props: {
    text: {
      type: String,
      default: "",
    },
    buttonColor: {
      type: String,
      default: "",
    },
    buttonVariant: {
      type: String,
      default: "elevated",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
